export default __webpack_public_path__ + "static/media/header-image.d76153dd.svg";